import { render, staticRenderFns } from "./DebtTourStats.vue?vue&type=template&id=be24caae&"
import script from "./DebtTourStats.vue?vue&type=script&lang=js&"
export * from "./DebtTourStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports